
import { config } from '../../config/config';
const BASE_URL = config.API.PORT_DB;

export const getUsersFilters = async (table,client,proyect,token) => {
  try {
    const response = await fetch(`${BASE_URL}/Users/${table}/${client}/${proyect}`, {
      method: "GET",
      headers: { "x-access-token": token },
    });
    return response.json();
    
  } catch (error) {
    throw new Error("Problem getting users");
  }
};

export const getUsersCLients = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/Clients`, {
      method: "GET",
      headers: { "x-access-token": token },
    });
    return response.json();
  } catch (error) {
    throw new Error("Problem with customer");
  }
};

export const getUsersClient = async (token,idClient) => {
  try {
    const response = await fetch(`${BASE_URL}/Clients/${idClient}`,{
        method: "Get",
        headers: { "x-access-Token": token },
      }
    );
    return response.json();
  } catch (error) {
    throw new Error("Problem with customer");
  }
};


export const getUsersProjects = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/Proyects`, {
      method: "GET",
      headers: { "x-access-token": token },
    });
    return response.json();
  } catch (error) {
    throw new Error("Project obtaining problem");
  }
};

export const getUsersPlatforms = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/Platforms`, {
      method: "GET",
      headers: { "x-access-token": token },
    });
    return response.json();
  } catch (error) {
    throw new Error("Platform obtaining problem");
  }
};

export const getUsersDataClient = async (token,options) => {
  try {
    const response = await fetch(`${BASE_URL}/DataClients/Clients/${options}`,{
        method: "GET",
        headers: { "x-access-token": token },
      }
    );
    return response.json();
  } catch (error) {
    throw new Error("Problem with customer data");
  }
};

export const getUsersDataClientProjects = async (token,options) => {
  try {
    const response = await fetch(`${BASE_URL}/DataClients/proyects/${options}`, {
      method: "GET",
      headers: { "x-access-token": token },
    });
    return response.json();
  } catch (error) {
    throw new Error("Problem data obtaining problem");
  }
};

export const getUsersDataClientPlatforms = async (token,options) => {
  try {
    const response = await fetch(`${BASE_URL}/DataClients/platforms/${options}`,
      {
        method: "GET",
        headers: { "x-access-token": token },
      }
    );
    return response.json();
  } catch (error) {
    throw new Error("Problem with the obtaining platform data");
  }
};

export const getUsersClientsProjects = async (token,idclient) => {
  try {
    const response = await fetch(`${BASE_URL}/Clients/${idclient}/Proyects`, {
        method: "GET",
        headers: { "x-access-token": token },
      }
    );
    return response.json();
  } catch (error) {
    throw new Error("Project problem in customers");
  }
};

export const getUsersClientsPlatforms = async (token,idclient) => {
  try {
    const response = await fetch( `${BASE_URL}/Clients/${idclient}/Platforms`,{
        method: "GET",
        headers: { "x-access-token": token },
      }
    );
    return response.json();
  } catch (error) {
    throw new Error("Problem with the obtaining of platforms in customers");
  }
};

export const getUsersRoles= async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/Roles`, {
      method: "GET",
      headers: { "x-access-token": token},
    });
    return response.json();
  } catch (error) {
    throw new Error("Problem with the obtaining of roles");
  }
};

export const postUsersAdd= async (body,table,token) => {
  try {
    const response =  await fetch(`${BASE_URL}/signup/${table}`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: { 
        "Content-Type": "application/json",
        "x-access-token" : token
      },
    });
    return response.json();
  } catch (error) {
    throw new Error("User registration problem");
  }
};

export const putUsersUpdate= async (infoUser,idUser,tableData,token) => {
  try {
    const response =  await fetch(`${BASE_URL}/Users/${tableData}/${idUser}`, {
      method: "PUT",
      body: JSON.stringify(infoUser),
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    });
    return response.json();
  } catch (error) {
    throw new Error("User registration problem");
  }
};

export const getInformation= async(token, table) =>{
    const res = await fetch(`${BASE_URL}/Users/${table}`, {
      method: "GET",
      headers: { "x-access-token": token },
    });
    return await res.json(); 
}

export const postClients= async (data,token) => {
  try {
    const response =  await fetch(`${BASE_URL}/Clients`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "x-access-Token": token,
      },
    });
    return response.json();
  } catch (error) {
    throw new Error("Customer creation problem");
  }
};

export const postProjects= async (data,token) => {
  try {
    const response =  await fetch(`${BASE_URL}/Proyects`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "x-access-Token": token,
      },
    });
    return response.json();
  } catch (error) {
    throw new Error("Project creation problems");
  }
};

export const postPlatforms= async (data,token) => {
  try {
    const response =  await fetch(`${BASE_URL}/Platforms`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "x-access-Token": token,
      },
    });
    return response.json();
  } catch (error) {
    throw new Error("Problem with the creation of the platforms");
  }
};

export const getUsersData= async (token,table) => {
  try {
    const response =  await fetch(`${BASE_URL}/Users/${table}`, {
      method: "GET",
      headers: { "x-access-Token": token },
    });
    return response.json();
  } catch (error) {
    throw new Error("Problem with user obtaining");
  }
};

export const getUserDataForName= async (token,Username,table) => {
  try {
    const response =  await fetch(
      `${BASE_URL}/Username/${table}/${Username}`, {
        method: "GET",
        headers: { "x-access-Token": token },
    });
    return response.json();
  } catch (error) {
    throw new Error("Problem with user information");
  }
};

